"use client";

import { Link, useRouter } from "@/i18n/routing";
import { getProductCardProps } from "@/lib/depict/dpc-helpers";
import {
  ComponentProps,
  MouseEventHandler,
  forwardRef,
  useCallback,
} from "react";

type Props = ComponentProps<typeof Link> & {
  depictProductId?: string;
  depictListingResultId?: string;
  depictSearchResultId?: string;
};

export const PrefetchLink = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      href,
      onMouseOver,
      depictProductId,
      depictListingResultId,
      depictSearchResultId,
      ...props
    },
    ref,
  ) => {
    const router = useRouter();

    const handleMouseOver: MouseEventHandler<HTMLAnchorElement> =
      useCallback(() => {
        router.prefetch(href.toString());
      }, [router, href]);
    return (
      <Link
        ref={ref}
        {...getProductCardProps({
          productId: depictProductId,
          listingId: depictListingResultId,
          searchResultId: depictSearchResultId,
        })}
        onMouseOver={(e) => {
          handleMouseOver(e);
          onMouseOver?.(e);
        }}
        href={href}
        {...props}
        prefetch={false}
      />
    );
  },
);

PrefetchLink.displayName = "PrefetchLink";
